import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './CtaSection.css';

const CtaSection = () => {
    const navigate = useNavigate();

    const handleJoinACMCommunity = () => {
        navigate('/contact');
    };

    return (
        <div className="cta-background">
            <motion.div 
                className="cta-container"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
            >
                <h2 className="cta-title">Ready to Take Your Next Step?</h2>
                <p className="cta-subtitle">
                    Join our vibrant community of tech enthusiasts and unlock endless possibilities for your career growth.
                </p>
                <motion.button
                    onClick={handleJoinACMCommunity}
                    className="cta-button"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Join ACM Community
                </motion.button>
            </motion.div>
        </div>
    );
};

export default CtaSection;
